// @ts-nocheck
import React from "react";
import useSelect from "hooks/useSelect";
import genRequest from "includes/request";
import { useQueryClient } from "react-query";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import UsersExporter from "../../UsersManager/components/UsersExporter/UsersExporter";
import { t } from "i18next";
import promiseToast from "components/Toasts/PromiseToast";
import useAccount from "classes/Accounts/hooks/useAccount";
import CustomTableToolbar from "components/Table/TableToolbar/CustomTableToolbar";

export default function UsersTableToolbar(props) {
	const { account } = useAccount();
	const { selectedRows, clearSelection } = props;
	const { confirmDelete } = useSelect();
	const QCL = useQueryClient();

	function handleDelete() {
		if (!selectedRows?.length) return false;
		let title = t("Contacts.ASKDELETE", {
			count: selectedRows?.length,
			name: selectedRows[0].firstName + " " + selectedRows[0].lastName,
		});
		confirmDelete(
			() => {
				delSelecteds();
			},
			null,
			title
		);
	}

	function delSelecteds() {
		let proms = selectedRows.map((user, x) => {
			let prom = false;
			if (user?.employeeId && user.employeeId !== account.employeeId)
				prom = new Promise((resolve, reject) => {
					setTimeout(() => {
						genRequest(
							`employees/${user.employeeId}`,
							null,
							"delete"
						).then((resp) => {
							resolve(resp);
						}, reject);
					}, 500 * x);
				});
			return prom;
		});

		let prom = Promise.allSettled(proms).then(() => {
			QCL.resetQueries(["Employes"]);
			clearSelection();
		});

		promiseToast(prom, {
			pending: t("Contacts.DELETING", { count: selectedRows?.length }),
		});
		return prom;
	}

	return (
		<CustomTableToolbar
			{...props}
			handleDelete={handleDelete}
			buttons={[
				{
					title: "delete",
					onClick: handleDelete,
				},
				{
					title: t("Contacts.EXPORT_TITLE"),
					icon: faUpload,
					value: t("Contacts.EXPORT"),
					popper: UsersExporter,
					className: "light-bg",
				},
			]}
		/>
	);
}
